module.exports = __webpack_public_path__ + "images/frontpage_sizes@1x.png?08f57ad1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_sizes@1x.png
// module id = 660
// module chunks = 7